<script setup lang="ts">
import FinestButton from '@/components/FinestButton.vue'
import FinestCard from '@/components/FinestCard.vue'
import ProjectsController from '@controllers/Investors/ProjectsController'
import { useI18n } from 'vue-i18n'

defineProps<{
  projectId: string
  title: string
  summary: { label: string; value: string }[]
}>()

const { t } = useI18n()
</script>

<template>
  <FinestCard :title="t('title')" icon="pi pi-check-circle">
    <div class="flex flex-col items-center gap-4 py-6 text-center">
      <span class="bg-success-subtle text-success flex size-16 items-center justify-center rounded-full">
        <i class="pi pi-check text-3xl!" aria-hidden="true" />
      </span>
      <h2 class="text-2xl font-bold tracking-tight">{{ t('heading') }}</h2>
      <p class="text-ink-2 max-w-prose">{{ t('description', { title }) }}</p>

      <dl class="border-line bg-surface-2 w-full max-w-130 rounded-[10px] border px-4 py-3 text-left">
        <div
          v-for="entry in summary"
          :key="entry.label"
          class="border-line-2 flex justify-between gap-3 py-1.5 text-sm not-last:border-b">
          <dt class="text-ink-3">{{ entry.label }}</dt>
          <dd class="font-semibold">{{ entry.value }}</dd>
        </div>
      </dl>

      <Link :href="ProjectsController.show(projectId)">
        <FinestButton variant="gradient" :label="t('action')" icon="pi pi-arrow-right" icon-pos="right" />
      </Link>
    </div>
  </FinestCard>
</template>

<i18n>
{
  "de": {
    "title": "Fertig",
    "heading": "Anfrage wurde eingereicht",
    "description": "Deine Anfrage zu „{title}“ ist eingereicht und liegt jetzt in Prüfung. Wir melden uns, sobald es etwas Neues gibt.",
    "action": "Zur Anfrage"
  },
  "en": {
    "title": "Done",
    "heading": "Request submitted",
    "description": "Your request for “{title}” has been submitted and is now in review. We will get in touch as soon as there is news.",
    "action": "To the request"
  }
}
</i18n>
